<div class="layout-topbar">
    <div class="ui-lg-1 ui-g-1">
        <a href="http://www.keystonekubb.com" target="_blank">
            <img alt="logo" class="topbar-image-small" src="assets/images/keystone_kubb_sm.png">
        </a>
    </div>
    <div *ngIf="ds.mobile" class="ui-g-1"></div>
    <div class="ui-lg-5 ui-g-10">
        <div class="topbar-title" style="display: inline-block;" translate>APP.NAME</div>
    </div>    
    <div *ngIf="!ds.mobile" class="ui-lg-6 ui-g-12 topbar-menu" style="text-align: right;">
        <ul class="topbar-menu" style="float: right;">
            <li>
                <a routerLink="/home" style="min-width: 1em; padding-left: 1em; padding-right: 1em;" translate>MENU.HOME</a>
            </li>
            <li  class="topbar-submenu">
                <a routerLink="/download" style="min-width: 1em; padding-left: 1em; padding-right: 1em;" translate>MENU.DOWNLOAD</a>
            </li>
            <li class="topbar-submenu">
                <a routerLink="/tournaments" style="min-width: 1em; padding-left: 1em; padding-right: 1em;" translate>MENU.TOURNAMENTS</a>
            </li>
            <li class="topbar-submenu">
                <a routerLink="/donate" style="min-width: 1em; padding-left: 1em; padding-right: 1em;" translate>MENU.DONATE</a>
            </li>
        </ul>
    </div>
    <div *ngIf="ds.mobile" class="ui-g-1">
        <i class="pi pi-bars" style="font-size: 150%" (click)="displayMobileMenu = !displayMobileMenu"></i>
    </div>
    <div *ngIf="displayMobileMenu && ds.mobile" class="ui-g-12 topbar-mobile-menu">
        <ul (click)="displayMobileMenu = !displayMobileMenu">
            <li>
                <a routerLink="/home" translate>MENU.HOME</a>
            </li>
            <li>
                <a routerLink="/download" translate>MENU.DOWNLOAD</a>
            </li>
            <li>
                <a routerLink="/tournaments"translate>MENU.TOURNAMENTS</a>
            </li>
            <li>
                <a routerLink="/donate" translate>MENU.DONATE</a>
            </li>
        </ul>
    </div>
</div>
